<template>
    <div class="tr" v-if="editMode">
        <span class="td">{{index}}</span>
        <span class="td editable"><textarea cols="10" name="salonName" rows="3" type="text"
                                            v-model="salon.name" v-validate.initial="'required'"></textarea>
         <span class="error-tooltip" v-if="errors.first('salonName')"> {{errors.first('salonName')}}</span>
        </span>
        <span class="td editable"><textarea cols="10" rows="3" type="text"
                                            v-model="salon.sid"></textarea></span>
        <span class="td editable"><textarea cols="10" name="phoneNumber" rows="3" type="text"
                                            v-model="salon.phone" v-validate="{regex: /^[\d ()+-]+$/}"></textarea>
        <span class="error-tooltip" v-if="errors.first('phoneNumber')"> {{errors.first('phoneNumber')}}</span></span>
        <span class="td editable">
            <textarea
                    cols="10"
                    name="latitude"
                    rows="3"
                    type="number"
                    v-model="salon.latitude"
                    v-validate="{min_value:-90,max_value:90}">
            </textarea>
            <span class="error-tooltip" v-if="errors.first('latitude')"> {{errors.first('latitude')}}</span>
        </span>
        <span class="td editable">
            <textarea cols="10"
                      name="longitude"
                      rows="3"
                      type="number"
                      v-model="salon.longitude"
                      v-validate="{min_value: -180, max_value: 180}">
            </textarea>
            <span class="error-tooltip" v-if="errors.first('longitude')"> {{errors.first('longitude')}}</span>
        </span>
        <span class="td editable"><textarea cols="10" rows="3" type="text"
                                            v-model="salon.supervisor"></textarea></span>
        <span class="td editable"><textarea cols="10" rows="3" type="text"
                                            v-model="salon.address"></textarea></span>
        <span class="td editable"><textarea cols="10" rows="3" type="text"
                                            v-model="salon.city"></textarea></span>
        <span class="td editable"><textarea cols="10" name="postalCode" rows="3" type="text"
                                            v-model="salon.postalCode" v-validate="{regex: /^[\d -]+$/}"></textarea>
         <span class="error-tooltip" v-if="errors.first('postalCode')"> {{errors.first('postalCode')}}</span>
        </span>
        <span class="td editable ms-container">
            <multiselect
                    :clear-on-select="false"
                    :close-on-select="false"
                    :deselectLabel="$t('multiselect.deselectLabel')"
                    :limit="15"
                    :limit-text=" count => `+ ${count}`"
                    :multiple="true"
                    :options="groups"
                    :placeholder="$t('multiselect.placeholder')"
                    :preserve-search="true"
                    :selectLabel="$t('multiselect.selectLabel')"
                    :selectedLabel="$t('multiselect.selectedLabel')"
                    :value="selectedGroups"
                    @input="changeGroups"
                    label="name"
                    placeholder="Pick some"
                    track-by="id"
                    v-model="selectedGroups"
            >
    <template slot="selection" slot-scope="{ values, search, isOpen }"><span
            class="multiselect__single"
            v-if="values.length &amp;&amp; !isOpen">Grupy: {{ values.length }}/{{groups.length}}</span></template>
  </multiselect>
            </span>
        <span class="td th points-container">
               <svg @click="edit" height="23" viewBox="0 -3 20 23" width="18"
                    :class="{'invalidated': !validated}" xmlns="http://www.w3.org/2000/svg">
                <circle class="a" cx="10"
                        cy="10" r="10"/>
                <path class="b"
                      d="M36.344,29.156H34.922a.17.17,0,0,1-.156-.109,4.869,4.869,0,0,0-.469-1.141.164.164,0,0,1,.016-.187l1-1a.151.151,0,0,0,0-.219L34,25.172a.151.151,0,0,0-.219,0l-1,1a.166.166,0,0,1-.187.031,4.869,4.869,0,0,0-1.141-.469.155.155,0,0,1-.109-.156V24.156A.148.148,0,0,0,31.188,24H29.313a.148.148,0,0,0-.156.156v1.422a.17.17,0,0,1-.109.156,4.869,4.869,0,0,0-1.141.469.164.164,0,0,1-.187-.016l-1-1a.151.151,0,0,0-.219,0L25.172,26.5a.151.151,0,0,0,0,.219l1,1a.166.166,0,0,1,.031.188,4.869,4.869,0,0,0-.469,1.141.155.155,0,0,1-.156.109H24.156a.148.148,0,0,0-.156.156v1.875a.148.148,0,0,0,.156.156h1.422a.17.17,0,0,1,.156.109,4.869,4.869,0,0,0,.469,1.141.164.164,0,0,1-.016.188l-1,1a.151.151,0,0,0,0,.219l1.328,1.328a.151.151,0,0,0,.219,0l1-1a.166.166,0,0,1,.187-.031,4.869,4.869,0,0,0,1.141.469c.062.016.094.094.094.172v1.406a.161.161,0,0,0,.172.156H31.2c.094,0,.141-.062.141-.156V34.938a.207.207,0,0,1,.125-.172,4.869,4.869,0,0,0,1.141-.469.164.164,0,0,1,.187.016l1,1a.151.151,0,0,0,.219,0l1.328-1.328a.151.151,0,0,0,0-.219l-1-1a.166.166,0,0,1-.031-.187,4.755,4.755,0,0,0,.469-1.125.155.155,0,0,1,.156-.109h1.422c.078.016.141-.062.141-.156V29.313A.148.148,0,0,0,36.344,29.156ZM30.25,33.063a2.813,2.813,0,1,1,2.813-2.812A2.821,2.821,0,0,1,30.25,33.063Z"
                      transform="translate(-20.25 -20.25)"/></svg>
                <template>
<div class="table points-list" v-if="serialsOptions.length > 0">
                  <div class="add-link">
                    <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
                    <button @click.prevent="addDevice" href="/">{{$t('salons.addSensor')}}</button>
                </div>
       <div class="tr">
           <span class="td ">{{$t('salons.sensor.name')}}</span>
           <span class="td ">{{$t('salons.sensor.serialNumber')}}</span>
           <span class="td ">{{$t('salons.sensor.port')}}</span>
           <span class="td ">{{$t('salons.sensor.active')}}</span>
           <span class="td">{{$t('salons.sensor.remove')}}</span>
       </div>
    <div :key="sensor.id" class="tr" v-for="sensor in salon.sensors">
        <span class="td editable"><input :placeholder="$t('salons.sensor.name')" type="text"
                                         v-model="sensor.name"></span>
        <span class="td editable">
        <multiselect
                :allowEmpty="false"
                :deselectLabel="$t('multiselect.deselectLabel')"
                :options="serialsOptions"
                :placeholder="$t('multiselect.placeholder')"
                :searchable="false"
                :selectLabel="$t('multiselect.selectLabel')"
                :selectedLabel="$t('multiselect.selectedLabel')"
                :show-labels="false"
                v-model="sensor.serialNumber"
        ></multiselect></span>
        <span class="td"><multiselect
                :allowEmpty="false"
                :deselectLabel="$t('multiselect.deselectLabel')"
                :options="portOptions"
                :placeholder="$t('multiselect.placeholder')"
                :searchable="false"
                :selectLabel="$t('multiselect.selectLabel')"
                :selectedLabel="$t('multiselect.selectedLabel')"
                :show-labels="false"
                v-model="sensor.portNumber"
        ></multiselect></span>
        <span class="td editable"><div @click="changeActive(sensor)" class="status">
            <font-awesome-icon class="active" icon="check-circle" size="lg" v-if="sensor.enabled"/>
            <font-awesome-icon class="disabled" icon="times-circle" size="lg" v-else/>
        </div>
        </span>
        <span class="td removal">
            <font-awesome-icon :class="{marked: salon.sensorIdsToDetach.includes(sensor.id)}"
                               @click="markForRemoval(sensor)"
                               class="disabled" icon="times-circle"
                               :title="$t('general.remove')" size="lg" style="cursor: pointer;"/>
        </span>
    </div>
</div>
                    <div class="text" v-else></div>
                </template>

        </span>
        <span class="td th remove">
            <div class="operations">
                <font-awesome-icon :class="{marked: removeSalonMark}" @click="removeSalon"
                                   class="disabled"
                                   icon="times-circle"
                                   size="lg"></font-awesome-icon>
            </div>
        </span>
    </div>
    <div :class="{edited: edited}" class="tr" v-else>
        <span class="td">{{index}}</span>
        <span class="td">{{salon.name}}</span>
        <span class="td">{{salon.sid}}</span>
        <span class="td">{{salon.phone}}</span>
        <span class="td">{{salon.latitude}}</span>
        <span class="td">{{salon.longitude}}</span>
        <span class="td">{{salon.supervisor}}</span>
        <span class="td">{{salon.address}}</span>
        <span class="td">{{salon.city}}</span>
        <span class="td">{{salon.postalCode}}</span>
        <span class="td">
{{$t('salons.groups')}}: {{salon.groups.length}}/{{groups.length}}
            </span>
        <span class="td th points-container">
            <div :title="$t('general.edit')" class="operations" style="cursor: pointer;">
            <svg @click="edit" height="23" viewBox="0 -3 20 23" width="18"
                 xmlns="http://www.w3.org/2000/svg">
                <circle class="a" cx="10"
                        cy="10" r="10"/>
                <path class="b"
                      d="M36.344,29.156H34.922a.17.17,0,0,1-.156-.109,4.869,4.869,0,0,0-.469-1.141.164.164,0,0,1,.016-.187l1-1a.151.151,0,0,0,0-.219L34,25.172a.151.151,0,0,0-.219,0l-1,1a.166.166,0,0,1-.187.031,4.869,4.869,0,0,0-1.141-.469.155.155,0,0,1-.109-.156V24.156A.148.148,0,0,0,31.188,24H29.313a.148.148,0,0,0-.156.156v1.422a.17.17,0,0,1-.109.156,4.869,4.869,0,0,0-1.141.469.164.164,0,0,1-.187-.016l-1-1a.151.151,0,0,0-.219,0L25.172,26.5a.151.151,0,0,0,0,.219l1,1a.166.166,0,0,1,.031.188,4.869,4.869,0,0,0-.469,1.141.155.155,0,0,1-.156.109H24.156a.148.148,0,0,0-.156.156v1.875a.148.148,0,0,0,.156.156h1.422a.17.17,0,0,1,.156.109,4.869,4.869,0,0,0,.469,1.141.164.164,0,0,1-.016.188l-1,1a.151.151,0,0,0,0,.219l1.328,1.328a.151.151,0,0,0,.219,0l1-1a.166.166,0,0,1,.187-.031,4.869,4.869,0,0,0,1.141.469c.062.016.094.094.094.172v1.406a.161.161,0,0,0,.172.156H31.2c.094,0,.141-.062.141-.156V34.938a.207.207,0,0,1,.125-.172,4.869,4.869,0,0,0,1.141-.469.164.164,0,0,1,.187.016l1,1a.151.151,0,0,0,.219,0l1.328-1.328a.151.151,0,0,0,0-.219l-1-1a.166.166,0,0,1-.031-.187,4.755,4.755,0,0,0,.469-1.125.155.155,0,0,1,.156-.109h1.422c.078.016.141-.062.141-.156V29.313A.148.148,0,0,0,36.344,29.156ZM30.25,33.063a2.813,2.813,0,1,1,2.813-2.812A2.821,2.821,0,0,1,30.25,33.063Z"
                      transform="translate(-20.25 -20.25)"/></svg>
</div>
        </span>
        <span class="td th remove"><font-awesome-icon :class="{marked: removeSalonMark}"
                                                      :title="$t('general.remove')"
                                                      @click="removeSalon" class="disabled"
                                                      icon="times-circle" size="lg"
                                                      style="cursor: pointer;"></font-awesome-icon></span>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { RepositoryFactory } from '@/api/RepositoryFactory';

const GroupRepository = RepositoryFactory.get('groups');

export default {
  name: 'Salon',
  components: {
    Multiselect,
  },
  props: {
    salon: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      groups: [],
      selectedGroups: [],
      editMode: false,
      portOptions: [1, 2, 3, 4, 5, 6, 7, 8],
      markedForRemoval: [],
      removeSalonMark: false,
      serialsOptions: [],
      edited: false,
    };
  },
  computed: {
    validated() {
      return this.errors.items.length <= 0;
    },
  },
  mounted() {
    const { token } = this.$store.getters;
    this.$validator.localize(this.$i18n.locale, {
      messages: {
        min_value: () => this.$t('validation.generic'),
        max_value: () => this.$t('validation.generic'),
        regex: () => this.$t('validation.generic'),
        required: () => this.$t('validation.requiredField'),
      },
    });
    this.groups = this.$store.getters.groups;
    if (this.salon.groups.length > 0) {
      this.salon.groups.forEach((v) => {
        this.selectedGroups.push(this.groups.find(entry => entry.id === v));
      });
    }
    this.salon.sensorIdsToDetach = [];
    for (const elem in this.salon.serialNameSelect) {
      this.serialsOptions.push(elem);
    }
    this.editMode = this.salon.editMode;
    this.edited = this.salon.edited;
  },
  methods: {
    changeGroups() {
      const newGroups = [];
      this.selectedGroups.forEach((v) => {
        newGroups.push(v.id);
      });
      this.salon.groups = newGroups;
    },
    edit() {
      this.edited = true;
      if (this.validated) {
        const { editMode } = this;
        if (this.editMode) {
          this.$emit('editModeOff');
        } else {
          this.$emit('editModeOn');
        }
        this.editMode = !editMode;
        this.salon.editMode = this.editMode;
        if (this.$vnode.key >= 0) {
          this.$emit('edited', this.salon);
        }
      }
    },
    changeActive(sensor) {
      sensor.enabled = !sensor.enabled;
    },
    markForRemoval(sensor) {
      if (sensor.id !== null) {
        if (this.salon.sensorIdsToDetach.includes(sensor.id)) {
          const index = this.salon.sensorIdsToDetach.indexOf(sensor.id);
          this.salon.sensorIdsToDetach.splice(index, 1);
        } else {
          this.markedForRemoval.push(sensor.id);
          this.salon.sensorIdsToDetach.push(sensor.id);
        }
      } else {
        const index = this.salon.sensors.indexOf(sensor);
        this.salon.sensors.splice(index, 1);
      }
    },
    addDevice() {
      this.salon.sensors.push({
        id: null,
        serialNumber: '',
        portNumber: 1,
        enabled: true,

      });
    },
    removeSalon() {
      if (this.salon.id > 0) {
        if (this.removeSalonMark) {
          this.removeSalonMark = false;
          this.$emit('removal', this.salon.id);
        } else {
          this.removeSalonMark = true;
          this.$emit('removal', this.salon.id);
        }
      } else {
        if (this.editMode) {
          this.$emit('editModeOff');
        }
        this.$emit('delete', this.$vnode.key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

    DIV.table.points-list {
        display: table;
        /*table-layout: fixed;*/
        transform: translate(-98%, 1%);
        margin-top: 25px;
        width: 1000px;
        /*box-shadow: none;*/
    }

    FORM.tr, DIV.tr {
        display: table-row;
        /*border: 1px solid lightgray;*/
    }

    .points-container {
        transition: 300ms ease-in all;
    }

    SPAN.td {
        display: table-cell;
        //padding: 20px;
        border-bottom: 1px solid $border-gray;
        border-right: 1px solid $border-gray;
        // color: $baseTextColor;
        text-align: left;
        /*width: 400px;*/
        cursor: default;
        transition: 300ms ease-in all;
        word-break: break-all;
        /*height: 50px;*/
        box-sizing: border-box;
        vertical-align: middle;
        padding: 10px;

        &.editable, &.removal {
            // border: 1px solid $peacock-blue;
            padding: 0;
            vertical-align: initial;
            text-align: center;
            position: relative;

            input {
                border: 1px solid $peacock-blue;
            }
        }

        &:first-child {
            font-weight: 900;
        }

        &:last-child {
            border-right: none;
        }

        input {
            border: none;
        }

        &.th {
            &:nth-last-child(2) {
                border-right: none;
            }
        }
    }

    .a {
        fill: $marine-blue;
    }

    .b {
        fill: $white;
    }

    .active {
        color: $peacock-blue;
    }

    .disabled {
        color: $marine-blue;
    }

    .td.status {
        text-align: center;
    }

    .operations {
        display: flex;
        align-items: center;
    }

    input {
        // color: $baseTextColor;
        font-size: rem(14px);
        line-height: 19px;
        padding: 20px;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }

    .add-link {
        font-size: rem(18px);
        color: #005fab;
        font-weight: 900;
        line-height: 40px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 36px;
        text-align: left;

        svg {
            padding-left: 0;
        }

        a {
            margin-left: 17px;
            text-decoration: none;

            &:active, &:hover, &:visited {
                color: #005fab;
            }
        }

    }

    .marked {
        color: $red;
    }

    button {
        border: none;
        background: none;
        cursor: pointer;
        color: #005fab;
        font-size: rem(18px);
        font-weight: bold;

        &.cancel, &.save {

            color: white;
            font-size: rem(18px);
            font-weight: bold;
            padding: 12px 50px;
            border-radius: 30px;
            transition: 300ms all ease-in;

        }

        &.save {
            background: #005fab;
            border: 1px solid #005fab;
            margin-left: 60px;
            margin-right: 21px;

            &:hover {
                color: #005fab;
                background: white;
            }
        }

        &.cancel {
            background-color: #002678;
            border: 1px solid #002678;

            &:hover {
                color: #002678;
                background: white;
            }
        }
    }

    .remove {
        svg {
            padding-top: 3px;
        }
    }

    textarea {
        resize: none;
        border: 1px solid $peacock-blue;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .ms-container {
        vertical-align: top !important;
    }

    .invalidated {
        filter: grayscale(100%) !important;
    }

    .error-tooltip {
        border: 2px solid $red;
        position: absolute;
        top: 50px;
        width: 210px;
        color: $red;
        background-color: lighten($red, 40%);
        left: 0;
        z-index: 150;
        padding: 15px;
    }

    .edited {
        background-color: #E5E5E5;
    }
</style>
